<template>
  <div class="mayday-web-parametric-main-layout">
    <!-- NAVBAR -->
    <MaydayWebParametricNavbarMenu
      class="mayday-web-parametric-navbar"
      :focus-is-product="focusIsProduct"
      :has-pictures="productHasPictures"
      @open-notification-modal="openNotificationModal"
      @open-contribution-modal="openContributionModal"
      @open-feedback-modal="openFeedbackModal"
      @focusIsFilter="focusingFilter"
    />
    <!-- MAIN -->
    <!-- DESKTOP & LAPTOPS -->
    <div class="mwp-main-container">
      <router-view
        @update-default-knowledge="updateDefaultKnowledge"
        @update-default-parameters="updateDefaultParameters"
        @update-default-external-id="updateDefaultExternalId"
        @update-has-prictures="productHasPictures = $event"
        @open-feedback-modal="openFeedbackModal"
        @close-feedback-modal="modals.isFeedbackModalOpen = false"
      ></router-view>
    </div>
    <!-- OTHERS (MODALS) -->
    <MaydayWebNotificationModal
      v-if="modals.isNotificationModalOpen"
      :display="modals.isNotificationModalOpen"
      @close="modals.isNotificationModalOpen = false"
    />
    <MaydayWebFeedbackDrawer
      v-if="modals.isFeedbackModalOpen"
      :display="modals.isFeedbackModalOpen"
      :content="modals.contentForFeedback"
      :content-parents="modals.contentParentsForFeedback"
      :path="modals.pathForFeedback"
      @success="handleSuccess"
      @close="modals.isFeedbackModalOpen = false"
    />
    <ContributionModal
      v-if="modals.isContribModalOpen"
      :open="modals.isContribModalOpen"
      :default-knowledge="defaultKnowledge"
      :defaultParameters="defaultParameters"
      @send-contribution="sendContribution"
      @close="modals.isContribModalOpen = false"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MaydayWebParametricNavbarMenu from './MaydayWebParametricNavbarMenu.vue';
import MaydayWebNotificationModal from '@/views/MaydayWeb/MaydayWebNotifications/MaydayWebNotificationModal';
import MaydayWebFeedbackDrawer from 'views/MaydayWeb/MaydayWebFeedbackDrawer.vue';
import ContributionModal from '@/components/Modals/ContributionModal/ContributionModal.vue';

export default {
  name: 'mayday-web-parametric',
  components: {
    MaydayWebParametricNavbarMenu,
    MaydayWebNotificationModal,
    MaydayWebFeedbackDrawer,
    ContributionModal,
  },
  props: {},
  data() {
    return {
      drawer: false,
      direction: 'btt',
      focusIsFilter: false,
      modals: {
        isNotificationModalOpen: false,
        isFeedbackModalOpen: false,
        contentForFeedback: {},
        pathForFeedback: [],
        contentParentsForFeedback: [],
        isContribModalOpen: false,
      },
      defaultKnowledge: '',
      defaultParameters: {},
      showFeedbackModal: false,
      productHasPictures: false,
    };
  },
  computed: {
    focusIsProduct() {
      return this.$route.name === 'web-product';
    },
    focusIsContent() {
      return this.$route.name === 'web-content';
    },
    focusIsStep() {
      return this.$route.name === 'web-content-step';
    },
    ...mapGetters('knowledgeModule', ['focusContent', 'focusStep']),
  },
  methods: {
    openNotificationModal() {
      this.modals.isNotificationModalOpen = true;
    },
    handleSuccess() {
      this.modals.isFeedbackModalOpen = false;
      this.$message({
        message: this.$t('knowledge.modals.feedback.success'),
        type: 'success',
      });
    },
    openFeedbackModal() {
      if (this.focusIsContent) {
        const { id, label, type } = this.focusContent;
        this.modals.contentForFeedback = {
          id,
          label,
          type,
        };
        this.modals.pathForFeedback = [{ id, label }];
        this.modals.contentParentsForFeedback = [];
      } else if (this.focusIsStep) {
        const { id, label, type } = this.focusStep;

        this.modals.contentForFeedback = {
          id,
          label,
          type,
        };
        this.modals.contentParentsForFeedback =
          this.focusStep.ancestorsContent.map((ancestor) => ({
            id: ancestor.id,
            label: ancestor.label,
          }));
        this.modals.contentParentsForFeedback.push(
          this.modals.contentForFeedback,
        );
        this.modals.pathForFeedback = [];
      }
      this.modals.isFeedbackModalOpen = true;
    },
    openContributionModal() {
      this.modals.isContribModalOpen = true;
    },
    focusingFilter() {
      this.focusIsFilter = true;
    },
    async sendContribution(contribution) {
      this.storeEvent(contribution);
      const success =
        await this.$services.parametricContents.createContribution(
          contribution,
        );
      if (success) {
        this.$message({
          message: `Contribution envoyée avec succès !`,
          type: 'success',
        });
      } else {
        this.$message(`Une erreur est survenue, veuillez réessayer`);
      }
    },
    updateDefaultKnowledge(newDefaultKnowledge) {
      this.defaultKnowledge = newDefaultKnowledge;
    },
    updateDefaultParameters(newDefaultParameters) {
      Object.assign(this.defaultParameters, newDefaultParameters);
    },
    updateDefaultExternalId(externalId) {
      Object.assign(this.defaultParameters, {
        externalId,
      });
    },
    storeEvent(contribution) {
      if (this.$route.path.includes('web-parametric')) {
        this.$services.events.general.contribution(
          contribution,
          window.location.href,
          'WEB_PARAMETRIC',
        );
      }
    },
  },
  watch: {
    $route(to) {
      if (to.name === 'web-content' && window.innerWidth < 1200) {
        this.drawer = true;
      }
      if (to.path.split('/')[2] !== 'product') {
        this.defaultKnowledge = '';
        this.defaultParameters = {};
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.content-drawer {
  :deep() .el-drawer__body {
    overflow: auto;
  }
}

.mayday-web-parametric-main-layout {
  height: 100vh;
  background-color: white;
}

.mwp-main-container {
  background-color: white;
}

@media only screen and (min-device-width: 1200px) {
  .mayday-web-parametric-navbar {
  }
}
</style>
